import {
    MAT_MOMENT_DATE_ADAPTER_OPTIONS,
    provideMomentDateAdapter,
    MatMomentDateModule,
    MomentDateAdapter,
} from '@angular/material-moment-adapter';
import {
    MatDialogActions,
    MatDialogContent,
    MAT_DIALOG_DATA,
    MatDialogTitle,
    MatDialogRef,
} from '@angular/material/dialog';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Kalender, KalenderService, RechteService, Role, Termin, TermineService} from 'kkm-library';
import {MatDatepickerInputEvent, MatDatepickerModule} from '@angular/material/datepicker';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {DateAdapter, MatOptionModule} from '@angular/material/core';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatTimepickerModule} from '@angular/material/timepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSelectModule} from '@angular/material/select';
import {MatButtonModule} from '@angular/material/button';
import {Component, OnInit, inject} from '@angular/core';
import {TextFieldModule} from '@angular/cdk/text-field';
import {MatChipsModule} from '@angular/material/chips';
import {MatInputModule} from '@angular/material/input';
import {MatRadioModule} from '@angular/material/radio';
import {MatIconModule} from '@angular/material/icon';
import {MatCardModule} from '@angular/material/card';
import {AuthenticationService} from 'kkm-library';
import {NotificationService} from 'kkm-library';
import {DeviceScaleService} from 'kkm-library';
import {CopyPasteService} from 'kkm-library';
import {lastValueFrom} from 'rxjs';
import 'moment/locale/de';

import {ALL_WEEK_DAYS, WeekDay} from '../weekDay';

@Component({
    selector: 'kkm-termin-form',
    templateUrl: './termin-form.component.html',
    styleUrls: ['./termin-form.component.scss'],
    imports: [
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        FormsModule,
        ReactiveFormsModule,
        MatCardModule,
        MatButtonModule,
        MatTooltipModule,
        MatIconModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatTimepickerModule,
        MatMomentDateModule,
        MatRadioModule,
        MatInputModule,
        TextFieldModule,
        MatSelectModule,
        MatOptionModule,
        MatSlideToggleModule,
        MatChipsModule,
        MatAutocompleteModule,
    ],
    providers: [
        provideMomentDateAdapter(),
        {provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: {useUtc: false}},
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_MOMENT_DATE_ADAPTER_OPTIONS]},
    ],
    // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TerminFormComponent implements OnInit {
    public authService = inject(AuthenticationService);
    private terminService = inject(TermineService);
    private kalenderService = inject(KalenderService);
    private rechteService = inject(RechteService);
    protected copyPasteService = inject(CopyPasteService);
    public deviceScaleService = inject(DeviceScaleService);
    private notification = inject(NotificationService);

    public dialogRef = inject(MatDialogRef<TerminFormComponent>);
    public data = inject<{termin: Termin}>(MAT_DIALOG_DATA);

    constructor() {
        this.zeit_ab = new FormControl(null);
        this.zeit_bis = new FormControl(null);

        if (this.data.termin) {
            this.termin = this.data.termin;

            if (this.termin.datum) this.termin.datum = new Date(this.termin.datum);
            if (this.termin.datum) this.zeit_ab = new FormControl(this.termin.datum);
            // if (this.termin.datum) this.zeit_ab = this.termin.datum;
            if (this.termin.datum_bis) this.termin.datum_bis = new Date(this.termin.datum_bis);
            if (this.termin.datum_bis) this.zeit_bis = new FormControl(this.termin.datum_bis);
            // this.termin.datum = moment
            //     .utc(this.termin.datum)
            //     .subtract(moment(this.termin.datum).utcOffset(), 'm')
            //     .toDate();
            // if (this.termin.datum_bis)
            //     this.termin.datum_bis = moment
            //         .utc(this.termin.datum_bis)
            //         .subtract(moment(this.termin.datum_bis).utcOffset(), 'm')
            //         .toDate();

            this.terminForm.patchValue(this.termin);
            this.terminForm.controls.anmeldungen.setValue(this.termin.anmeldungen ?? false);
        }
    }

    termin: Termin | undefined;

    terminForm = new FormGroup({
        id: new FormControl<number>(0, {nonNullable: true}),
        betreff: new FormControl('', {nonNullable: true, validators: [Validators.required]}),
        ort: new FormControl('', {nonNullable: true}),
        beschreibung: new FormControl('', {nonNullable: true}),
        kalender_id: new FormControl<number>(1, {nonNullable: true}),
        datum: new FormControl<Date | null>(null, Validators.required),
        datum_bis: new FormControl<Date | null>(null),
        weekDays: new FormControl(
            ALL_WEEK_DAYS.filter(weekDay => weekDay.default),
            {nonNullable: true},
        ),
        teilnehmer_grp: new FormControl<number[]>([], {nonNullable: true}),
        einladung: new FormControl(false, {nonNullable: true}),
        anmeldungen: new FormControl(false, {nonNullable: true}),
        anmeldungen_vielleicht: new FormControl(false, {nonNullable: true}),
        anmeldungen_bis: new FormControl<number>(0, {nonNullable: true}),
        anzeige_teilnehmer: new FormControl('keine', {nonNullable: true}),
    });
    zeit_ab: FormControl<Date | null>;
    zeit_bis: FormControl<Date | null>;

    kalender: Kalender[] = [];
    gruppen: Role[] = [];

    public weekDays: WeekDay[] = ALL_WEEK_DAYS;

    ngOnInit(): void {
        this.loadKalender();
        this.loadGroups();
    }

    async loadKalender() {
        this.kalender = await lastValueFrom(this.kalenderService.getKalender());
        this.kalender = this.kalender.filter(kal => kal.editable);
        // this.terminForm.controls.kalender_id.setValue(this.kalender[0].id || 1);
    }

    async loadGroups() {
        this.gruppen = await lastValueFrom(this.rechteService.getGruppen());
    }

    updateEndDate(startDate: MatDatepickerInputEvent<Date>): void {
        const endDateControl = this.terminForm.controls.datum_bis;
        // Überprüfe, ob das Enddatum vor dem Startdatum liegt
        if (endDateControl.value && startDate.value && startDate.value > endDateControl.value) {
            // Setze das Enddatum auf null oder einen Standardwert
            endDateControl.setValue(startDate.value); // Du kannst auch einen Standardwert setzen, z.B. new Date()
        }
    }

    /** Dialog schließen */
    onCancel(): void {
        this.dialogRef.close(false);
    }

    speichern(): void {
        if (!this.terminForm.valid) {
            this.notification.error('Es sind nicht alle Felder ausgefüllt');
            return;
        }

        let newTermin: Termin = {
            betreff: '',
            datum: new Date(),
            kalender_id: 1,
        };
        newTermin = Object.assign(newTermin, this.terminForm.value);

        newTermin.datum = new Date(newTermin.datum);

        newTermin.datum.setHours(0);
        newTermin.datum.setMinutes(0);
        if (this.zeit_ab.value) {
            const zeit_ab = new Date(this.zeit_ab.value);

            newTermin.datum.setHours(zeit_ab.getHours());
            newTermin.datum.setMinutes(zeit_ab.getMinutes());
        }
        newTermin.datum.setSeconds(0);

        if (newTermin.datum_bis) {
            newTermin.datum_bis = new Date(newTermin.datum_bis);
            newTermin.datum_bis.setHours(0);
            newTermin.datum_bis.setMinutes(0);
            if (this.zeit_bis.value) {
                const zeit_bis = new Date(this.zeit_bis.value);
                newTermin.datum_bis.setHours(zeit_bis.getHours());
                newTermin.datum_bis.setMinutes(zeit_bis.getMinutes());
            }
            newTermin.datum_bis.setSeconds(0);
        }

        // newTermin.datum = moment.utc(newTermin.datum).add(moment(newTermin.datum).utcOffset(), 'm').toDate();
        // if (newTermin.datum_bis)
        //     newTermin.datum_bis = moment
        //         .utc(newTermin.datum_bis)
        //         .add(moment(newTermin.datum_bis).utcOffset(), 'm')
        //         .toDate();

        const handleResponse = (response: Termin) => {
            if (response.id) {
                this.notification.success('Gespeichert');
                this.dialogRef.close(true);
            }
        };

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const handleError = (error: any) => {
            this.notification.error(`Beim Speichern ist ein Fehler aufgetreten. ${error.error.message}`);
        };

        if (newTermin.id === 0) {
            console.log('new');
            newTermin.weekDays = this.terminForm.value.weekDays;
            lastValueFrom(this.terminService.newTermin(newTermin)).then(handleResponse, handleError);
        } else {
            if (newTermin.id) {
                console.log('edit');
                lastValueFrom(this.terminService.editTermin(newTermin.id, newTermin)).then(handleResponse, handleError);
            }
        }
    }

    public weekDaysToFormFieldText(): string {
        const diToDo = ['TUESDAY', 'WEDNESDAY', 'THURSDAY'];
        const moToDo = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY'];
        const moToFr = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'];
        const moToSa = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
        const value = this.terminForm.get('weekDays')?.value;

        if (!value) {
            return '';
        }
        if (value.length === 3) {
            for (const item of value) {
                if (diToDo.indexOf(item.value) === -1) {
                    return this.allDaysAsAbbreveation(value);
                }
            }
            return 'Di. - Do.';
        }
        if (value.length === 4) {
            for (const item of value) {
                if (moToDo.indexOf(item.value) === -1) {
                    return this.allDaysAsAbbreveation(value);
                }
            }
            return 'Mo. - Do.';
        }
        if (value.length === 5) {
            for (const item of value) {
                if (moToFr.indexOf(item.value) === -1) {
                    return this.allDaysAsAbbreveation(value);
                }
            }
            return 'Mo. - Fr.';
        }
        if (value.length === 6) {
            for (const item of value) {
                if (moToSa.indexOf(item.value) === -1) {
                    return this.allDaysAsAbbreveation(value);
                }
            }
            return 'Mo. - Sa.';
        }
        if (value.length === 7) {
            return 'Mo. - So.';
        }
        if (value) {
            return this.allDaysAsAbbreveation(value);
        }

        return this.allDaysAsAbbreveation(value);
    }

    private allDaysAsAbbreveation(value: WeekDay[]): string {
        let result = '';
        value.forEach(item => (result += item.displayValue.substr(0, 2) + '., '));
        return result.substr(0, result.length - 2);
    }
}
